import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import has from "lodash/has";
import Layout from "layouts/DashboardManage";
import { SpinnerRainbow } from "components/Spinner";
import Table from "./Table";
import { getAccuracy } from "store/actions/accuracyAction";
import { getSelectedClient } from "store/actions/clientAction";
import Filters from "./Filters";
import NoData from "components/NoData";
import { hasProperty } from "helpers/object";
import Pagination from "components/Pagination";
import Translate from "helpers/Translate";

const Accuracy = () => {
  const dispatch = useDispatch();
  const selectedClient = useSelector(state => state.client.selectedClient);
  const accuracyReport = useSelector(state => state.accuracy.getAccuracy);
  const isAccuracyLoading = useSelector(
    state => state.accuracy.isLoadingAccuracy
  );
  const [page, setPage] = useState(1);

  const PAGE_RANGE = 5;
  const RECORDS_PER_PAGE = 10;

  useEffect(() => {
    if (selectedClient) {
      dispatch(getAccuracy({ clientId: selectedClient.id }));
    } else {
      dispatch(getSelectedClient());
    }
  }, [selectedClient, dispatch]);

  const handleOnFilter = user => {
    dispatch(getAccuracy({ clientId: selectedClient.id, userId: user.id }));
  };

  const onPageChange = targetPage => {
    targetPage = targetPage.selected + 1;
    setPage(targetPage);
    dispatch(
      getAccuracy({
        clientId: selectedClient.id,
        page: targetPage
      })
    );
  };

  return (
    <Layout>
      <div className="accuracy-container">
        {Translate({
          id: "accuracy_report_for",
          values: [hasProperty(() => selectedClient.name, "...")]
        })}
        <div className="page-name my-30"></div>
        {/* <!-- Filters --> */}
        <Filters
          handleOnFilter={metadata => handleOnFilter(metadata)}
          selectedClient={selectedClient}
        />
        {isAccuracyLoading && <SpinnerRainbow />}
        {accuracyReport === null && <NoData showBorder={true} />}
        {!isAccuracyLoading && has(accuracyReport, "stats") && (
          <Table data={accuracyReport.stats} />
        )}
      </div>

      {/* Paginate */}
      {accuracyReport?.meta?.[0] && (
        <Pagination
          onPageChange={onPageChange}
          data={{
            total_pages: Math.ceil(
              accuracyReport.meta[0].total_records / RECORDS_PER_PAGE
            ),
            total_records: accuracyReport.meta[0].total_records,
            page_range: PAGE_RANGE,
            current_page: page
          }}
        />
      )}
    </Layout>
  );
};

Accuracy.propTypes = {
  error: PropTypes.object
};

export default Accuracy;
